import React from 'react';
import { useSelector } from 'react-redux';
import EquipmentTemplate from '../../components/equiqtemplate/EquipmentTemplate';
import Img1 from '../../assest/Self-Drive.png';
import Img2 from '../../assest/Remote.png';
import Img3 from '../../assest/ TrackLoader.png';

// Without operator list with translations
const withoutOperatorList = (language) => [
  {
    name: {
      gb: "Self-Drive Mini Excavator",
      sa: "حفارة صغيرة ذاتية القيادة",
      fr: "Mini-pelle autotractée",
      de: "Selbstfahrender Mini-Bagger"
    },
    image: Img1,
    specs: {
      gb: "Ideal for small DIY projects with easy operation.",
      sa: "مثالي للمشاريع الصغيرة التي يمكن تنفيذها ذاتيًا مع تشغيل سهل.",
      fr: "Idéal pour les petits projets de bricolage avec une utilisation facile.",
      de: "Ideal für kleine DIY-Projekte mit einfacher Bedienung."
    },
    description: {
      gb: "Compact and user-friendly excavator for projects without operators.",
      sa: "حفارة مدمجة وسهلة الاستخدام للمشاريع بدون مشغلين.",
      fr: "Pelle compacte et conviviale pour les projets sans opérateurs.",
      de: "Kompakter und benutzerfreundlicher Bagger für Projekte ohne Bediener."
    },
  },
  {
    name: {
      gb: "Remote-Controlled Loader",
      sa: "لودر يعمل عن بعد",
      fr: "Chargeuse télécommandée",
      de: "Fernbedienbarer Lader"
    },
    image: Img2,
    specs: {
      gb: "Operated remotely for enhanced safety and efficiency.",
      sa: "يعمل عن بعد لتحسين السلامة والكفاءة.",
      fr: "Opéré à distance pour une sécurité et une efficacité accrues.",
      de: "Fernbedienbar für mehr Sicherheit und Effizienz."
    },
    description: {
      gb: "Advanced loader suitable for areas where operator presence is limited.",
      sa: "لودر متقدم مناسب للمناطق التي يكون فيها وجود المشغل محدودًا.",
      fr: "Chargeuse avancée adaptée aux zones où la présence d'un opérateur est limitée.",
      de: "Fortschrittlicher Lader für Bereiche mit begrenzter Bedienerpräsenz."
    },
  },
  {
    name: {
      gb: "Automated Compact Track Loader",
      sa: "لودر مسار مضغوط آلي",
      fr: "Chargeuse compacte sur chenilles automatisée",
      de: "Automatisierter Kompaktkettenlader"
    },
    image: Img3,
    specs: {
      gb: "Self-operating machinery for repetitive or hazardous tasks.",
      sa: "آلات ذاتية التشغيل للمهام المتكررة أو الخطرة.",
      fr: "Machinerie autonome pour les tâches répétitives ou dangereuses.",
      de: "Selbstbetriebene Maschinerie für repetitive oder gefährliche Aufgaben."
    },
    description: {
      gb: "Robust equipment designed to operate without human operators on site.",
      sa: "معدات قوية مصممة للعمل بدون مشغلين بشريين في الموقع.",
      fr: "Équipement robuste conçu pour fonctionner sans opérateurs humains sur site.",
      de: "Robuste Ausrüstung für den Betrieb ohne menschliche Bediener vor Ort."
    },
  },
];

// Translations for WithoutOperator page
const translations = {
  gb: {
    heading: "Equipment Without Operator",
    introText: "Advanced machinery designed to operate efficiently without an on-site operator.",
    categoriesTitle: "Available Models",
    featuredTitle: "Highlighted Equipment",
    featuredDescription: "Top equipment designed for autonomous or remote operation.",
  },
  sa: {
    heading: "معدات بدون مشغل",
    introText: "آلات متقدمة مصممة للعمل بكفاءة دون وجود مشغل في الموقع.",
    categoriesTitle: "النماذج المتاحة",
    featuredTitle: "المعدات المميزة",
    featuredDescription: "أفضل المعدات المصممة للتشغيل الذاتي أو عن بعد.",
  },
  fr: {
    heading: "Équipement sans opérateur",
    introText: "Machinerie avancée conçue pour fonctionner efficacement sans opérateur sur site.",
    categoriesTitle: "Modèles disponibles",
    featuredTitle: "Équipement en vedette",
    featuredDescription: "Meilleur équipement conçu pour un fonctionnement autonome ou à distance.",
  },
  de: {
    heading: "Geräte ohne Bediener",
    introText: "Fortschrittliche Maschinen, die effizient ohne Bediener vor Ort betrieben werden können.",
    categoriesTitle: "Verfügbare Modelle",
    featuredTitle: "Hervorgehobene Ausrüstung",
    featuredDescription: "Top-Ausrüstung für autonomen oder Fernbetrieb.",
  },
};

const WithoutOperator = () => {
  const { language } = useSelector((state) => state.language);
  const t = translations[language] || translations.gb;
  
  // Process equipment list with current language
  const processedEquipmentList = withoutOperatorList().map(item => ({
    name: item.name[language] || item.name.gb,
    image: item.image,
    specs: item.specs[language] || item.specs.gb,
    description: item.description[language] || item.description.gb
  }));

  return (
    <EquipmentTemplate
      content={t}
      equipmentList={processedEquipmentList}
      language={language}
    />
  );
};

export default WithoutOperator;